import { Component, OnInit, ViewChild, type ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { SharedComponentsModule } from '../../../../shared/components/shared-components.module';
import { offset } from 'handsontable/helpers/dom';
import moment from 'moment';
// Heavy libs (alasql/xlsx/exceljs/file-saver) should load lazily inside methods
import { CookieService } from 'ngx-cookie-service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RfqGenerateFormService } from '../../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { HttpClient } from '@angular/common/http';
import { PurchaseOrderService } from '../purchase-order.service';
import { SupplierPoSWRService, type PoQuery } from './po-swr.service';
// import * as Excel from 'exceljs';
// import * as FileSaver from 'file-saver';

const labelMap: Record<string, string> = {
  name: 'Name',
  address: 'Address',
  contact: 'Contact',
  phone: 'Phone',
  fax: 'Fax',
  email: 'Email',
  billingAddress: 'Billing Address',
  mpsBuyerCode: 'MPS Buyer Code',
  mpsSupplierCode: 'MPS Supplier Code',
  PIC: 'PIC',
  vat: 'VAT'

};

@Component({
  selector: 'app-supplier-purchase-order-list',
  templateUrl: './supplier-purchase-order-list.component.html',
  styleUrls: ['./supplier-purchase-order-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplierPurchaseOrderListComponent {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  userId!: number;
  userRole!: string;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  headerData: any;
  showLoader: boolean = true;
  nextMpsCode: number = 0;
  isChatOpen: boolean = false;
  searchKeyword: string = '';
  operationType: string = 'buyerPurchaseOrder';
  AllPOs: any[] = [];
  limit: number = 10; // Rows per page
  offset: number = 0; // Current page offset
  archivedLimit: number = 10; // Rows per page
  archivedOffset: number = 0; // Current page offset
  totalRecords: number = 0; // Total number of records
  archivedTotalRecords: number = 0;
  sortField: string = '';
  sortDirection: string = '';
  docStatus: string = 'all';
  fromDate: any;
  toDate: any;
  selectedPODetails: number[] = [];
  documentData: any[] = [];
  archivedDocumentData: any[] = [];
  documentDataTotalRecords: number = 0;
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  archivedLoaded: boolean = false;
  showConfirmationDialogue: boolean = false;
  isWrapDescription: boolean = false;
  isLoading: boolean = false;
  searchParam: string = '';
  selectedPO: number[] = [];
  selectedArchivedPO: number[] = [];
  supplierUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  dropdownOpen:boolean = false;
  private hasAutoExpandedAllOnce: boolean = false;
  private shouldAutoExpandFirst: boolean = true;
  private poListSub: any = null;
  private currentPoQueryKey: string | null = null;
  private poArchivedSub: any = null;
  private currentPoArchivedQueryKey: string | null = null;


  columns = [
    { name: 'Buyer', prop: 'companyName', visible: true },
    { name: 'Document Type', prop: 'docType', visible: true },
    { name: 'Reference', prop: 'rfqRefNumber', visible: true },
    { name: 'Approved By', prop: 'approvedBy', visible: true },
    { name: 'Status', prop: 'docStatus', visible: true },
    { name: 'Date', prop: 'rfqDate', visible: true },

    { name: 'Quote before date', prop: 'quotedByDate', visible: false },
    { name: 'Vessel', prop: 'vesselName', visible: false },
    { name: 'Port Country', prop: 'portCountry', visible: false },
    { name: 'Port Name', prop: 'portName', visible: false },
    { name: 'Buyer Contact Name', prop: 'contact', visible: false },
    // { name: "Supplier Contact Name", prop: "rfqRefNumber", visible: false },
    // { name: "Total Cost", prop: "approvedBy", visible: false },
    { name: 'Delivery date', prop: 'requestDeliveryDate', visible: false },
    { name: 'Actions', prop: 'action', visible: true },
    { name: 'Track Status', prop: 'trackStatus', visible: true },
    // { name: "Expiry Date", prop: "rfqDate", visible: false },
  ];
  // Define toggleable columns
  columnOptions = [
    { key: 'quotationDate', label: 'Quote Date', visible: false },
    { key: 'rating', label: 'Rating', visible: false },
    { key: 'leadTime', label: 'Lead Time In Days', visible: false },
  ];

  cancelReason: string = '';
  customReason: string = '';
  statusColors: { [key: string]: string } = {
    Approved: '#0D8000',
    Submitted: '#FFA600',
    Draft: '#003BFF',
    // Canceled: '#dd1102',
    Rejected: '#FF0000',
  };

  filterStatuses = [
    { name: 'Pending', label: 'Order' },
    { name: 'Accepted', label: 'Order' },
    { name: 'Rejected', label: 'Order' },
    { name: 'ALL', label: 'Order' },
  ];

  // removed duplicate constructor further below; merged injections into the main one

  filterStatusesRfqAndQuote = [
    { name: 'Acknowledged', label: 'RFQ' },
    { name: 'Declined', label: 'RFQ' },
    { name: 'Lost', label: 'RFQ' },
    { name: 'Lapsed', label: 'RFQ' },
    { name: 'Unactioned', label: 'RFQ' },
    { name: 'Accepted', label: 'Quote' },
    { name: 'Declined', label: 'Quote' },
    { name: 'Draft', label: 'Quote' },
    { name: 'Quoted', label: 'Quote' },
    { name: 'Withdrawn', label: 'Quote' }
  ]

  items = [
    // {           
    //   label: 'Request Delivery Date',
    //   prop: 'requestDeliveryDate',   
    //   selected: false,
    // },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote Before Date',prop:'quotedByDate',selected:false},
  ];  
  archivedItems = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },

    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote Before Date',prop:'quotedByDate',selected:false},
  ];

  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Submitted to Supplier:' },
    // { name: 'Acknowledged', heading: 'RFQ Acknowledged:' },
    // { name: 'Declined', heading: 'RFQ Declined:' },
    // { name: 'Lost', heading: 'RFQ Lost:' },
    { name: 'Expired', heading: 'RFQ Expired:' },
    // { name: 'Submitted', heading: 'RFQ Submitted:' },
    { name: 'Draft', heading: 'RFQ Drafted:' },
    { name: 'Canceled', heading: 'RFQ Canceled:' },
    { name: 'Created', heading: 'RFQ Created:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Recieved' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },
    { name: 'Quoted', heading: 'Quotation Submitted' },
    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
  ];

  rfqStatuses = [
    'Unactioned',
    'Acknowledged',
    'Quoted',
    'Under Review',
    'Clarification Requested',
    'Approved',
    'Rejected',
    'Awarded',
    'Closed',
    'Open',
    'In Review',
    'Awaiting Supplier Response',
    'Canceled',
    'Draft',
    'Declined',
    'Lost',
    'Created',
  ];

  activeIndexes: number[] = [this.filterStatuses.length - 1];
  activeIndex: number = this.filterStatuses.length - 1;
  messages: { sender: string; message: string; time: string }[] = [];

  selectedStatus: string = 'ALL';


  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup:boolean = false;
  selectedBuyer: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax:'N/A'

  };

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private snack: MatSnackBar,
    private RfqGenerateFormService: RfqGenerateFormService,
    private iconRegistry: MatIconRegistry,
    private fullLoaderService: FullLoaderService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private PurchaseOrderService: PurchaseOrderService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private poSWR: SupplierPoSWRService,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
      // this.sanitizer.bypassSecurityTrustResourceUrl(`https://mps-cdn-dev.s3.eu-west-1.amazonaws.com/assets/images/excel.svg`)
    );
  }

  async ngOnInit() {
    const queryParams = this.route.snapshot.queryParamMap;
    console.log('query params', queryParams);

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];
      console.log('statusParam', statusParam);
      console.log('labelParam', labelParam);

      if (statusParam && labelParam) {
        //  When params are present, use them
        this.selectedStatus = statusParam;
        this.docStatus = statusParam;
        const index = this.filterStatuses.findIndex(
          (status) => status.name.toLowerCase() === statusParam.toLowerCase()
        );

        this.activeIndex = index;
      } else {
        //  Fallback when params are NOT provided
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }
    });

    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');
    await Promise.allSettled([
      this.fetchAllDocuments(),
      this.fetchUsers(),
    ]);
  }

  private buildPoQuery(activeFlag: 0 | 1): PoQuery {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    return {
      searchParam: this.searchParam,
      userId: Number(this.cookieService.get('userId')),
      docStatus: this.docStatus,
      fromDate,
      toDate,
      sortField: this.sortField,
      sortDirection: this.sortDirection as any,
      limit: activeFlag === 1 ? this.limit : this.archivedLimit,
      offset: activeFlag === 1 ? this.offset : this.archivedOffset,
      activeFlag,
      operationType: 'supplierPurchaseOrder',
    } as PoQuery;
  }

  async fetchAllDocuments() {
    let fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    let toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    console.log({ fromDate });
    console.log({ toDate });
    console.log('docStatus', this.docStatus);
    console.log('sortField', this.sortField);
    console.log('sortDirection', this.sortDirection);
    console.log('limit', this.limit);
    console.log('offset', this.offset);
    console.log('searchparam', this.searchParam);
    this.showLoader = true;
    try {
      const q = this.buildPoQuery(1);
      const key = this.poSWR.keyOf(q);
      const needsResubscribe = this.currentPoQueryKey !== key;
      if (needsResubscribe) {
        if (this.poListSub) {
          this.poListSub.unsubscribe?.();
          this.poListSub = null;
        }
        this.currentPoQueryKey = key;
        this.poListSub = this.poSWR.getList$(q, true).subscribe(async (response) => {
          if (!response || !Array.isArray(response.rows)) return;
          const enrichedRows = await Promise.all(
            response.rows.map(async (row: any) => {
              const r = { ...row };
              r.id = r.id ?? r.purchaseOrderId;
              r.statusColor = this.statusColors?.[r.docStatus] || '#727272';
              r.rfqDateFormatted = r.rfqDate ? moment(r.rfqDate).format('DD/MM/YYYY') : '-';
              return r;
            })
          );
          this.documentData = enrichedRows;
          // Auto-expand once for ALL on initial load
          if (this.expandedRowId == null && this.documentData.length > 0 && this.shouldAutoExpandFirst) {
            const first = this.documentData[0];
            this.expandedRowId = first.id;
            if (!first.statusesStages) {
              first.statusesStages = this.buildRfqStages(first);
              first.statusesStages = this.buildOtherStages(first);
            }
            this.hasAutoExpandedAllOnce = true;
            this.shouldAutoExpandFirst = false;
          }
          // Ensure stages for currently expanded row when present in page
          if (this.expandedRowId != null) {
            const match = this.documentData.find((r: any) => (r.id ?? r.purchaseOrderId) === this.expandedRowId);
            if (match && !match.statusesStages) {
              match.statusesStages = this.buildRfqStages(match);
              match.statusesStages = this.buildOtherStages(match);
            }
          }
          this.totalRecords = response.totalElements ?? 0;
          this.documentData = [...this.documentData];

          console.log('this.documentData', this.documentData);
          this.showLoader = false;
          this.cdr.markForCheck();
        });
      }
      const cached = this.poSWR.getCached(q);
      if (!cached) {
        this.fullLoaderService.showLoader();
        try {
          await this.poSWR.refresh(q);
        } finally {
          this.fullLoaderService.hideLoader();
        }
      } else {
        this.poSWR.refresh(q);
      }
    } catch (e) {
      console.error('Error fetching POs', e);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  async fetchArchivedAllDocuments() {
    try {
      const q = this.buildPoQuery(0);
      const key = this.poSWR.keyOf(q);
      const needsResubscribe = this.currentPoArchivedQueryKey !== key;
      const cached = this.poSWR.getCached(q);
      this.showLoader = !cached;
      if (needsResubscribe) {
        if (this.poArchivedSub) {
          this.poArchivedSub.unsubscribe?.();
          this.poArchivedSub = null;
        }
        this.currentPoArchivedQueryKey = key;
        this.poArchivedSub = this.poSWR.getList$(q, true).subscribe(async (response) => {
          if (!response || !Array.isArray(response.rows)) return;
          const enrichedRows = await Promise.all(
            response.rows.map(async (row: any) => {
              const r = { ...row };
              r.id = r.id ?? r.purchaseOrderId;
              r.statusColor = this.statusColors?.[r.docStatus] || '#727272';
              r.rfqDateFormatted = r.rfqDate ? moment(r.rfqDate).format('DD/MM/YYYY') : '-';
              return r;
            })
          );
          this.archivedDocumentData = enrichedRows;
          this.archivedTotalRecords = response.totalElements ?? 0;
          this.showLoader = false;
          this.cdr.markForCheck();
        });
      }
      if (!cached) {
        this.fullLoaderService.showLoader();
        try {
          await this.poSWR.refresh(q);
        } finally {
          this.fullLoaderService.hideLoader();
        }
      } else {
        this.poSWR.refresh(q);
      }
    } catch (e) {
      console.error('Error fetching archived POs', e);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }


  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
  // Method to handle page change event from ngx-datatable
  onPageChange(event: any) {
    this.offset = event.offset; // Update offset from the page change event
    this.fetchAllDocuments(); // Fetch data with new offset
  }

  // Method to handle search functionality
  onSearch() {
    this.offset = 0; // Reset offset for new search
    this.archivedOffset = 0;
    this.fetchAllDocuments();
    // this.fetchArchivedAllDocuments()
  }

  // Handle sort change event from ngx-datatable
  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    console.log('Sorting RFQ documents by', this.sortField, this.sortDirection);

    // Apply sorting and fetch data accordingly
    // Note: Sorting in your backend should be implemented to support `sortField` and `sortDirection`
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {}

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset; // Update offset from the page change event
    this.fetchArchivedAllDocuments(); // Fetch data with new offset
  }

  // async downloadRfq(filePath: string, refNo: string) {
  //   this.showLoader = true;
  //   let fileName = refNo + '.pdf';
  //   await this.dataTransferService.downloadFile(filePath, fileName);
  //   this.showLoader = false;
  // }

  // OpenRfq(filePath: string) {
  //   window.open(filePath, '_blank');
  // }


  openPO(poId:number,rfqId:number,quoteId:number,purchaseOrderStatusValue:string){
    this.router.navigate([
      "operations","purchase-order-details",
    ],
      {
        queryParams: { rfqId:rfqId, quoteId: quoteId, purchaseOrderId: poId, status: purchaseOrderStatusValue}
      }
    );
  }

  // editRfq(tabId: number, rfqId: number) {
  //   if (tabId == 1) {
  //     this.router.navigate(['dashboard', 'rfq', 'create', 'header'], {
  //       queryParams: { productType: 'cart', id: null, rfqId: rfqId },
  //     });
  //   } else if (tabId == 2) {
  //     this.router.navigate(['dashboard', 'rfq', 'create', 'line-items'], {
  //       queryParams: { productType: 'cart', id: null, rfqId: rfqId },
  //     });
  //   } else if (tabId == 5) {
  //     this.router.navigate(['dashboard', 'rfq', 'create', 'lpreview'], {
  //       queryParams: { productType: 'cart', id: null, rfqId: rfqId },
  //     });
  //   }
  // }

  // async resentRfq(rfqId: number) {
  //   this.showLoader = true;

  //   let formdata = {
  //     rfqId: Number(rfqId),
  //   };

  //   await this.RfqGenerateFormService.sendRfqAcknowledgment(formdata);

  //   this.showLoader = false;
  // }

  // OpenSupplierProductPopUp(isNew?: boolean, row?: any, userId?: any) {
  //   this.router.navigate(
  //     [
  //       'dataManagement',
  //       {
  //         outlets: {
  //           'form-outlet': ['product-binding', userId],
  //         },
  //       },
  //     ],
  //     {
  //       state: { supplierId: userId }, // Add your data here
  //     }
  //   );
  // }

  // OpenSupplierPreviewPopup(row?: any, userId?: any, companyId?: any) {
  //   this.router.navigate([
  //     // "dataManagement",
  //     // 'pro',
  //     //  userId
  //     'settings',
  //     'profile',
  //     'about',
  //     userId,
  //     companyId,
  //   ]);
  // }

  // OpenSupplierProfilePopup(row?: any, userId?: any, companyId?: any) {
  //   this.router.navigate(['settings', 'supplierProfile', userId, companyId]);
  // }

  // exportAll() {
  //   this.showLoader = true;

  //   let exportData: any[] = [];

  //   this.documentData.forEach((docDetails) => {
  //     exportData.push({
  //       Buyer: docDetails.companyName,
  //       'Document Type': docDetails.docType,
  //       Reference: docDetails.rfqRefNumber,
  //       // "Approved By": docDetails.approvedBy,
  //       Status: docDetails.docStatus,
  //       Date: docDetails.rfqDate,
  //       // "Doc": docDetails.name,
  //       // "Quote before date": docDetails.name,
  //       // "Vessel": docDetails.name,
  //       // "Port Country": docDetails.name,
  //       // "Port Name": docDetails.name,
  //       // "Buyer Contact Name": docDetails.name,
  //       // "Supplier Contact Name": docDetails.name,
  //       // "Total Cost": docDetails.name,
  //       // "Delivery date": docDetails.name,
  //       // "Expiry Date": docDetails.name,
  //     });
  //   });

  //   alasql('SELECT * INTO XLSX("RFQ Data",{headers:true}) FROM ?', [
  //     exportData,
  //   ]);

  //   this.showLoader = false;
  // }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand && this.heading) {
      // Lazy-load archived data on first expand
      if (!this.archivedLoaded) {
        this.fetchArchivedAllDocuments();
        this.archivedLoaded = true;
      }
      this.heading.nativeElement.scrollIntoView({
        behavior: 'smooth', // Smooth scroll
        block: 'start', // Align the section to the top of the viewport
      });
      setTimeout(() => {
        if (this.archivedSection) {
          this.heading.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start', // Align the table at the top of the viewport after heading
          });
        }
      }, 100);
    }
  }

  isColumnVisible(prop: string): boolean {
    const column = this.columns.find((col) => col.prop === prop);
    return column ? column.visible : false;
  }

  search() {}

  cancelFilter() {
    this.docStatus = 'all';
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.fetchAllDocuments();
    if (this.archivedLoaded) {
      this.fetchArchivedAllDocuments();
    }
  }

  toggleColumn(column: any) {
    column.visible = !column.visible;
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    const ids = this.documentData.map((item) => item.purchaseOrderId);

    if (section == 'active') {
      if (checked) {
        this.selectedPO = this.documentData.map((item) => item.purchaseOrderId);
        this.selectedPODetails = this.selectedPO;
      } else {
        this.selectedPO = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedPO = this.archivedDocumentData.map(
          (item) => item.purchaseOrderId
        );
      } else {
        this.selectedArchivedPO = [];
      }
    }
  }

  // selectDeselectPO(event: any, supplierRfqDetailsId: any, section: string) {

  //   const checked = event.target.checked;

  //   if (section == 'active') {
  //     if (checked) {
  //       this.selectedPO.push(supplierRfqDetailsId)
  //     }
  //     else {
  //       this.selectedPO = this.selectedPO.filter(id => id !== supplierRfqDetailsId);
  //     }
  //   }
  //   else {
  //     if (checked) {
  //       this.selectedArchivedPO.push(supplierRfqDetailsId)
  //     }
  //     else {
  //       this.selectedArchivedPO = this.selectedArchivedPO.filter(id => id !== supplierRfqDetailsId);
  //     }
  //   }

  // }

  // async rfqOperation(operation: string, rfqId :number) {

  //   this.selectedPO.push(rfqId)

  //   let data = {
  //     operation:operation,
  //     selectedPOId : this.selectedPO
  //   }

  //     if (operation == 'delete') {
  //       this.showLoader = true;
  //       await this.SettingsService.rfqOperations(data)
  //       this.showLoader = false;
  //       this.snack.open('RFQ deleted successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }

  //     else if (operation == 'restore') {
  //       this.showLoader = true;
  //       await this.SettingsService.rfqOperations(data)
  //       this.showLoader = false;
  //       this.snack.open('RFQ restored successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }

  //     else if (operation == 'cancel') {
  //       this.showLoader = true;
  //       await this.SettingsService.rfqOperations(data)
  //       this.showLoader = false;
  //       this.snack.open('RFQ cancelled successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }
  //     else if (operation == 'resend') {
  //       this.showLoader = true;

  //       let formdata = {
  //         rfqId:Number(rfqId)
  //       }

  //       await this.RfqGenerateFormService.reSendRfqAcknowledgment(formdata)

  //       this.showLoader = false;
  //       this.snack.open('RFQ resent successfully', 'OK', {
  //         duration: 3000,
  //       });
  //     }

  //   this.fetchAllDocuments()
  //   this.fetchArchivedAllDocuments()
  //   this.selectedArchivedPO = []
  //   this.selectedPO = []

  //   }

  selectDeselectPO(
    event: any,
    poDetailsId: any,
    poId: any,
    section: string
  ) {
    const checked = event.target.checked;

    if (section == 'active') {
      if (checked) {
        // console.log({poId});
        this.selectedPO.push(poId);
        this.selectedPODetails.push(poDetailsId);
      } else {
        this.selectedPO = this.selectedPO.filter((id) => id !== poId);
        this.selectedPODetails = this.selectedPODetails.filter(
          (id) => id !== poDetailsId
        );
      }
    } else {
      if (checked) {
        this.selectedArchivedPO.push(poId);
      } else {
        this.selectedArchivedPO = this.selectedArchivedPO.filter(
          (id) => id !== poDetailsId
        );
      }
    }
    console.log("selectedPO",this.selectedPO);
    console.log("selectedPoDetials",this.selectedPODetails);
  }

  isChecked(poId: number, section: string) {
    if (section == 'active') {
      return this.selectedPO.includes(poId);
    } else {
      return this.selectedArchivedPO.includes(poId);
    }
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment(); // Get current time
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    // Handle the difference based on time
    if (diffInSeconds < 60) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInSeconds} seconds ago)`;
    } else if (diffInMinutes < 60) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInMinutes} minutes ago)`;
    } else if (diffInHours < 24) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInHours} hours ago)`;
    } else if (diffInDays === 1) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (Yesterday)`;
    } else {
      return moment(rfqDate).format('DD MMM YYYY'); // Show date with month and year
    }
  }

  getRemainingTime(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    if (
      !row.quotedByDate ||
      ['Lost', 'Declined', 'Expired'].includes(row.docStatus)
    ) {
      // if(row.docStatus=='Declined'){
      //   return { label: '-', color: 'black', tooltip: 'You have declined this RFQ' };
      // }else if(row.docStatus=='Lost'){
      //    return { label: ' ', color: 'black', tooltip: 'RFQ awarded to another Supplier' };
      // }
      // return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
      return { label: '', color: 'black', tooltip: '' };
    }

    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed' };
      return { label: '', color: '#000000', tooltip: '' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed'};
        // return { label: '-', color: '#000000', tooltip: 'Quote window closed'};
        return { label: '', color: '#000000', tooltip: '' };
      }
    }
  }

  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000'; // Default to black if no match
  }

  // openRfqDetails(rfqId: number) {
  //   console.log('Navigating to RFQ details');
  //   this.router.navigate(['/dashboard', 'rfq', 'create', 'header'], {
  //     queryParams: { productType: 'cart', rfqId: rfqId },
  //   });
  // }
  // /dashboard/quote/create/preview?rfqId=302&quoteId=1
  // /dashboard/quote/quote-details?supplierId=326&quoteId=128&rfqId=550
  // openQuoteDetails(rfqId: number, quoteId: number, supplierId: number) {
  //   console.log('Navigating to Quote details');
  //   this.router.navigate(['/dashboard', 'quote', 'quote-details'], {
  //     queryParams: { supplierId: supplierId, quoteId: quoteId, rfqId: rfqId },
  //   });
  // }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  //  onStatusSelect(status: string, index: number, label: string) {
  //   this.activeIndex = index;
  //   if (label === 'RFQ') {
  //     if (this.selectedStatus.includes(status)) {
  //       return;
  //     }
  //     if (
  //       this.selectedStatus[0] === 'Unactioned' &&
  //       status === 'Acknowledged'
  //     ) {
  //       this.selectedStatus.push('Acknowledged');
  //       this.activeIndexes.push(index);
  //       this.docStatus += `,Acknowledged`;
  //     } else if (
  //       this.selectedStatus[0] === 'Acknowledged' &&
  //       status === 'Unactioned'
  //     ) {
  //       this.selectedStatus.push('Unactioned');
  //       this.activeIndexes.push(index);
  //       this.docStatus += `,Unactioned`;
  //     } else {
  //       if (status !== 'ALL') {
  //         this.docStatus = status;
  //       } else {
  //         this.docStatus = '';
  //       }
  //       this.selectedStatus = [status];
  //       this.activeIndexes = [index];
  //     }
  //     this.offset = 0;

  //     this.fetchAllDocuments();
  //   } else if (label === 'Quote') {
  //     this.router.navigate(['/operations/supplier-quote-list'], {
  //       queryParams: {
  //         selectedStatus: status,
  //         label: label,
  //       },
  //     });
  //   }
  // }

  onStatusSelect(status: string, index: number, label: string) {
    if (label === 'RFQ') {
      this.router.navigate(['/operations/supplier-rfq-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    } else if (label === 'Quote') {
      this.router.navigate(['/operations/supplier-quote-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    }else if(label === 'Order'){
      if (this.selectedStatus.includes(status)) {
        return;
      }
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      // Reset expansion; auto-expand once for ALL
      this.expandedRowId = null;
      this.shouldAutoExpandFirst = status === 'ALL' && !this.hasAutoExpandedAllOnce;
      console.log(
        'triggered status selection and now docstatus->',
        this.docStatus
      );
      this.fetchAllDocuments();
    }
  }

  async purchaseOrderOperation(operation: string) {
    if (operation == 'unArchiveSupplierPOs') {
      if (this.selectedArchivedPO.length == 0) {
        this.snack.open('Please select atleast one', 'OK', {
          duration: 3000,
        });
        return;
      }

      this.showLoader = true;
      // await this.SettingsService.rfqOperations({
      //   operation: operation,
      //   selectedPOId: this.selectedArchivedPO,
      // });
      await this.PurchaseOrderService.purchaseOrderListOperations({
        operation: operation,
        selectedPOId: this.selectedArchivedPO,
      })
      // Optimistically move from archived -> active
      const unarchivedIds = new Set(this.selectedArchivedPO);
      const toUnarchive = this.archivedDocumentData.filter((row: any) => unarchivedIds.has(row.purchaseOrderId));
      this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !unarchivedIds.has(row.purchaseOrderId));
      if (toUnarchive.length > 0) {
        this.documentData = [...toUnarchive, ...this.documentData];
        this.totalRecords += toUnarchive.length;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
      }
      const qArchived = this.buildPoQuery(0);
      const qActive = this.buildPoQuery(1);
      this.poSWR.patchList(qArchived, (resp: any) => {
        const rows = (resp?.rows || []).filter((r: any) => !unarchivedIds.has(r.purchaseOrderId));
        const total = Math.max(0, (resp?.totalElements ?? 0) - toUnarchive.length);
        return { ...resp, rows, totalElements: total };
      });
      this.poSWR.patchList(qActive, (resp: any) => {
        const rows = toUnarchive.concat(resp?.rows || []);
        const total = (resp?.totalElements ?? 0) + toUnarchive.length;
        return { ...resp, rows, totalElements: total };
      });
      this.snack.open('Items unarchived', 'OK', { duration: 3000 });
    } else {
      if (this.selectedPO.length == 0) {
        this.snack.open('Please select atleast one.', 'OK', {
          duration: 3000,
        });
        return;
      }

      let data = {
        operation: operation,
        selectedPOId: this.selectedPODetails,
      };

      if (operation == 'archiveSupplierPOs') {
        this.showLoader = true;
        console.log('Data to make the rfq Archive->', data);
        await this.PurchaseOrderService.purchaseOrderListOperations(data)
        // Optimistically move from active -> archived
        const archivedIds = new Set(this.selectedPO);
        const toArchive = this.documentData.filter((row: any) => archivedIds.has(row.purchaseOrderId));
        this.documentData = this.documentData.filter((row: any) => !archivedIds.has(row.purchaseOrderId));
        if (toArchive.length > 0 && this.isArchivedExpand) {
          this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
          this.archivedTotalRecords += toArchive.length;
        }
        this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);
        const qActive = this.buildPoQuery(1);
        const qArchived = this.buildPoQuery(0);
        this.poSWR.patchList(qActive, (resp: any) => {
          const rows = (resp?.rows || []).filter((r: any) => !archivedIds.has(r.purchaseOrderId));
          const total = Math.max(0, (resp?.totalElements ?? 0) - toArchive.length);
          return { ...resp, rows, totalElements: total };
        });
        this.poSWR.patchList(qArchived, (resp: any) => {
          const rows = toArchive.concat(resp?.rows || []);
          const total = (resp?.totalElements ?? 0) + toArchive.length;
          return { ...resp, rows, totalElements: total };
        });
        this.snack.open('Items archived', 'OK', { duration: 3000 });
      } 
      // else if (operation == 'markAsOpen') {
      //   this.showLoader = true;
      //   await this.SettingsService.rfqOperations(data);
      //   this.showLoader = false;
      //   this.snack.open('Items marked as open', 'OK', {
      //     duration: 3000,
      //   });
      // } else if (operation == 'markAsUnopen') {
      //   this.showLoader = true;
      //   await this.SettingsService.rfqOperations(data);
      //   this.showLoader = false;
      //   this.snack.open('Items marked as unopen', 'OK', {
      //     duration: 3000,
      //   });
      // }
    }

    const qActive = this.buildPoQuery(1);
    const qArchived = this.buildPoQuery(0);
    this.poSWR.refresh(qActive);
    if (this.archivedLoaded) {
      this.poSWR.refresh(qArchived);
    }
    this.selectedArchivedPO = [];
    this.selectedPO = [];
    this.selectedPODetails = [];
    this.showLoader = false;
  }

  selectedColumns: { label: string; prop: string }[] = [];
  updateSelectedColumns() {
    // Create a map of label to prop
    this.selectedColumns = this.items
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.items.filter((i) => i.selected)
    );
    this.updateSelectedColumns();
  }

  getRemainingTimeForQuoteDate(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      return { label: 'Overdue', color: '#000000', tooltip: '' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        return { label: 'Overdue', color: '#000000', tooltip: '' };
      }
    }
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  expandedRowId: number | null = null;
  toggleExpandedRow(row: any) {
    this.expandedRowId = this.expandedRowId === row.id ? null : row.id;
    if (this.expandedRowId === row.id && !row.statusesStages) {
      row.statusesStages = this.buildRfqStages(row);
      row.statusesStages = this.buildOtherStages(row);
      this.cdr.markForCheck();
    }
  }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Declined' || row.docStatus === 'Canceled') {
      return 'stage-declined';
    }

    // console.log('label received ->', label);
    switch (label) {
      case 'Declined':
        return 'stage-declined';
      case 'Expired':
        return 'stage-lapsed';
      default:
        return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.archivedItems.filter((i) => i.selected)
    );
    this.updateArchivedSelectedColumns();
  }
  archivedSelectedColumns: { label: string; prop: string }[] = [];
  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)

    console.log('archieve selected columns', this.archivedSelectedColumns);
  }

  async RestorePo(isConfirmed: boolean, row: any) {
    if (isConfirmed) {
      try {
        this.showLoader = true;
        await this.PurchaseOrderService.purchaseOrderListOperations({
          operation: 'unArchiveSupplierPOs',
          selectedPOId: [row.purchaseOrderId],
        })
        // Optimistically move one item from archived -> active
        const idx = this.archivedDocumentData.findIndex((r: any) => r.purchaseOrderId === row.purchaseOrderId);
        if (idx !== -1) {
          const [moved] = this.archivedDocumentData.splice(idx, 1);
          this.documentData = [moved, ...this.documentData];
          this.totalRecords += 1;
          this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - 1);
          const qArchived = this.buildPoQuery(0);
          const qActive = this.buildPoQuery(1);
          this.poSWR.patchList(qArchived, (resp: any) => {
            const rows = (resp?.rows || []).filter((r: any) => r.purchaseOrderId !== row.purchaseOrderId);
            const total = Math.max(0, (resp?.totalElements ?? 0) - 1);
            return { ...resp, rows, totalElements: total };
          });
          this.poSWR.patchList(qActive, (resp: any) => {
            const rows = [moved].concat(resp?.rows || []);
            const total = (resp?.totalElements ?? 0) + 1;
            return { ...resp, rows, totalElements: total };
          });
        }
        // Background refresh
        const qActive2 = this.buildPoQuery(1);
        const qArchived2 = this.buildPoQuery(0);
        this.poSWR.refresh(qActive2);
        this.poSWR.refresh(qArchived2);
        this.snack.open('PO has been restored successfully!', 'OK', { duration: 3000 });
      } catch (error) {
        console.error('Error while restoring PO:', error);
        this.snack.open('Failed to restore PO. Please try again.', 'OK', {
          duration: 3000,
        });
      } finally {
        this.showLoader = false;
      }
    } else {
      this.snack.open('Restore operation was canceled.', 'OK', {
        duration: 3000,
      });
    }
  }

  getDeliveryDate(row: any): string {
    if (!row.onTimeDeliveryOrderBy) return '';

    const baseDate = new Date(row.onTimeDeliveryOrderBy);
    const deliveryDays = Number(row.quotedDeliveryInDays) || 0;
    baseDate.setDate(baseDate.getDate() + deliveryDays);

    // Format as dd/MM/yyyy
    return baseDate.toLocaleDateString('en-GB'); 
  }


  async fetchAllPOs() {
    try {
      let fromDate = this.fromDate
        ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        : null;
      this.operationType = 'exportSupplierPos';
      console.log('During export hit docStatus->', this.docStatus);
      const response = await this.PurchaseOrderService.fetchAllPurchaseOrderBySupplierId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.limit,
        this.offset,
        1,
        this.operationType
      );
      // console.log('Response from exportAllServicesByAdmin:', response);
      if (response && Array.isArray(response.rows)) {
        this.AllPOs = response.rows;
      } else {
        console.error('Invalid response structure', response);
      }

      // console.log('Fetched All Quotes Data:', this.AllPOs);
    } catch (error) {
      console.error('Error fetching all Quotes:', error);
      throw error; // Rethrow the error to be handled by the caller
    }
  }
  async exportAllPOs() {
    try {
      this.fullLoaderService.showLoader('Exporting PO Details...');

      await this.fetchAllPOs();

      if (!this.AllPOs || this.AllPOs.length === 0) {
        alert('No POs available to export.');
        return;
      }
      console.log('All POs Data:', this.AllPOs);

      const exportData: any[] = [];

      this.AllPOs.forEach((row: any, index: number) => {
        const flattenedProduct = {
          'Sr. No.': index + 1,
          'Order Reference': row.purchaseOrderRefNumber,
          'RFQ Reference': row.rfqRefNumber || '',
          'Quote Reference' : row.quoteRefNumber || '',
          
          'Buyer':row.buyerName || '',
          'Owner': row.supplierName || '',

          'Status':
            row.purchaseOrderStatusValue === 'Submitted' ? 'Pending' : row.purchaseOrderStatusValue || '',
          'Port Name': row.portName || '',
          'RFQ Date': row.rfqDate || '',
          'Purchase Order Date': row.purchaseOrderDate || '',
          'Rejection Date': row.purchaseOrderStatusValue === 'Rejected'? row.poUpdatedAt : '',
          'Quote Before Date': row.quotedByDate || '',
          'Vessel ETA': row.vesselEta || '',
          'Vessel ETD': row.vesselEtd || '',
          'Request For Delivery Date': row.requestDeliveryDate || '',
        };

        exportData.push(flattenedProduct);
      });

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(
        2,
        '0'
      )}-${String(today.getMonth() + 1).padStart(
        2,
        '0'
      )}-${today.getFullYear()}`;
      const fileName = `Supplier_POs_List_${formattedDate}.xlsx`;

      // Use XLSX to export data (lazy-loaded)
      const XLSX = await import('xlsx');
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'POs');
      XLSX.writeFile(wb, fileName);

      this.snack.open('POs data exported successfully!', 'OK', {
        duration: 5000,
      });
    } catch (error) {
      console.error('Error while exporting POs:', error);
      this.snack.open('Failed to export POs data.', 'OK', {
        duration: 5000,
      });
    } finally {
      //this.importExportOperationLoader = false;
      this.fullLoaderService.hideLoader();
    }
  }

  buildRfqStages(rfq: any) {
    const sortedStages = (rfq.rfqStatusStages || []).sort(
      (a: any, b: any) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    // if(sortedStages.length !==0){
    //   rfq.docStatus = sortedStages[sortedStages.length -1].statusName;
    // }
    let rfqCount = 0;
    if (rfq.suppliers?.length > 0) {
      rfqCount = rfq.suppliers.length;
    }

    const stagesArray: any[] = [];
    let hasAcknowledged = false;
    let hasDeclined = false;
    let hasUnactioned = false;
    let hasCreated = false;
    let createdDate = '';
    let hasDraft = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Acknowledged') hasAcknowledged = true;
      else if (stage.statusName === 'Declined') hasDeclined = true;
      else if (stage.statusName === 'Unactioned') hasUnactioned = true;
      else if (stage.statusName === 'Created') hasCreated = true;
      else if (stage.statusName === 'Draft') {
        hasDraft = true;
        createdDate = this.formatDate(stage.createdAt);
      }
    }
    if (!hasCreated) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Created', 'RFQ'),
        label: 'RFQ Created',
        date:
          createdDate !== '' ? createdDate : this.formatRfqDate(rfq.rfqDate),
        completed: true,
      });
    }

    sortedStages.forEach((stage: any) => {
      stagesArray.push({
        heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
        label:
          stage.statusName === 'Unactioned'
            ? `RFQ Sent(${rfqCount})`
            : `RFQ ${stage.statusName}`,
        date: this.formatDate(stage.createdAt),
        completed: true,
      });
    });

    if (rfq.docStatus === 'Unactioned' && !hasUnactioned) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
        label: `RFQ Sent(${rfqCount})`,
        date: this.formatDate(rfq.rfqDate),
        completed: true,
      });
    }
    // If RFQ is expired, append it at the end (if not already in stages)
    if (
      rfq.docStatus === 'Expired' &&
      !stagesArray.some((s) => s.label === 'Expired')
    ) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Expired', 'RFQ'),
        label: 'RFQ Expired',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }

    // if (!hasAcknowledged && !hasDeclined) {
    //   stagesArray.push({
    //     heading: this.getHeadingFromLabel('Acknowledged', 'RFQ'),
    //     label: 'Acknowledged',
    //     date: '',
    //     completed: false,
    //   });
    // }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];

    let quoteCount = 0;
    let latestQuoteDate = '';
    if (rfq.suppliers?.length > 0) {
      for (let supplier of rfq.suppliers) {
        if (supplier.rfqStatus === 3) {
          quoteCount++;
          latestQuoteDate = supplier.quotationDate;
        }
      }
    }
    console.log({quoteCount, latestQuoteDate});
    if (quoteCount > 0) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quote', 'Quote'),
        label: `Quotation received(${quoteCount})`,
        date: latestQuoteDate ? latestQuoteDate:'',
        completed: true,
      });
    } else {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quote', 'Quote'),
        label: ' Quotation received(0)',
        date: '',
        completed: false,
      });
    }

    stagesArray.push({
      heading: 'PO Confirmation',
      label: 'PO Confirmation',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'Delivered Onboard',
      label: 'Delivered',
      date: '',
      completed: false,
    });

    return stagesArray;
  }

  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const list =
      entityType === 'RFQ' ? this.rfqStagesList : this.quoteStagesList;
    const match = list.find(
      (stage) => stage.name.toLowerCase() === label.toLowerCase()
    );
    return match ? match.heading : label;
  }

  isRfqLapsed(quotedByDate: string | Date): boolean {
    return new Date() > new Date(quotedByDate);
  }

  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  // formatDate(input: string | Date): string {
  //   // First, try converting the input to a Date object
  //   let date: Date;

  //   // Check if input is already a Date object, if not, try parsing the string
  //   if (input instanceof Date) {
  //     date = input;
  //   } else {
  //     // Try to parse the string into a valid date
  //     date = new Date(input);
  //     // If the parsed date is invalid, return an error message
  //     if (isNaN(date.getTime())) {
  //       throw new Error('Invalid date format');
  //     }
  //   }

  //   // Format the date to DD/MM/YYYY
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const month = String(date.getMonth() + 1).padStart(2, '0');
  //   const year = date.getFullYear();

  //   return `${day}/${month}/${year}`;
  // }

  alreadyAssignedSupplierUsers() {
    // Find all POs that already have a supplierUserName
    const alreadyAssignedPos = this.selectedPO
      .map((poId: any) => {
        const po = this.documentData.find((data: any) => data.purchaseOrderId === poId);
        return po && po.supplierUserName ? po.poId : null;
      })
      .filter((poId: any) => poId !== null);

    console.log({ alreadyAssignedPos });
    if (alreadyAssignedPos.length > 0) {
      const poIds = alreadyAssignedPos.join(', '); // Join the RFQ IDs into a string
      this.snack.open(`User is already assigned to PO IDs: ${poIds}`, 'OK', {
        duration: 5000,
      });
      return;
    }
  }

  async toggleUserSelection(item: any) {
    
    if (this.selectedPO.length === 0) {
      this.snack.open(
        'Please select at least one PO before selecting a user.',
        'OK',
        {
          duration: 3000,
        }
      );
      return;
    }

    item.selected = !item.selected;

    if (item.selected) {
      try {
        // Call the SettingsService to assign the user
        this.showLoader = true;
        const response = await this.SettingsService.assignPOToSupplierUser(
          this.selectedPO,
          Number(this.cookieService.get('userId')),
          item.id
        );
        
        await this.fetchAllDocuments();
        this.selectedPO = [];
        item.selected = false;
        this.showLoader = false;
        this.snack.open('User assigned to PO successfully.', 'OK', {
          duration: 3000,
        });
      } catch (error) {
        this.showLoader = false;
        // If the API call fails, handle the error here
        this.snack.open('Failed to assign user to PO.', 'OK', {
          duration: 3000,
        });
        throw error; // Re-throw the error to be caught in the calling method
      }
    }
  }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    // Check if we've reached the bottom of the menu content
    if (
      menuContent.scrollTop + menuContent.clientHeight >=
        menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.supplierUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  async fetchUsers(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')), // supplierId
        this.userlimit, // limit
        this.useroffset // offset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.supplierUsersList = [...this.supplierUsersList, ...response.rows];
        this.useroffset++; // Increment offset for next batch of users

        console.log('supplierUserList', this.supplierUsersList);
      } else {
        console.error('Invalid response structure:', response);
      }
    } catch (error) {
      console.error('Error fetching buyer users:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async save(isConfirmed: boolean) {
    if (isConfirmed) {
      // Proceed with the save operation

      this.showLoader = true;

      if (this.cancelReason === 'Other') {
        this.cancelReason = this.customReason.trim();
      }
      console.log('cancel reason', this.cancelReason);
      console.log('RFQ cancelled');
      this.showConfirmationDialogue = false;
      let data = {
        selectedPOId: this.selectedPO,
        operation: 'cancelRfq',
        rfqStatus: 13,
      };

      await this.SettingsService.buyerRfqOperations(data);
      this.showLoader = false;
      this.snack.open('RFQ Cancelled', 'OK', {
        duration: 3000,
      });
      this.selectedPO = [];
      await this.fetchAllDocuments();
    } else {
      // User cancelled the operation
      this.selectedPO = [];
      this.showConfirmationDialogue = false;
    }
  }
  cancel() {
    this.selectedPO = [];
    this.showConfirmationDialogue = false;
  }

  ngOnDestroy() {
    if (this.poListSub) {
      this.poListSub.unsubscribe?.();
      this.poListSub = null;
    }
    if (this.poArchivedSub) {
      this.poArchivedSub.unsubscribe?.();
      this.poArchivedSub = null;
    }
  }
  openCancellationBox(rfqId: any) {
    this.selectedPO = [rfqId];
    this.showConfirmationDialogue = true;
  }
  masterSelected: boolean = false;

  selectedCount: number = 4;

  //  async onReminderClick(rfq: any) {
  //     // UI-only for now
  //     console.log('Reminder clicked for RFQ:', rfq);

  //     if (this.selectedSupplierForReminders.length < 1) {
  //       this.snack.open(
  //         'Please select at least one supplier with status Acknowledged or Unactioned to send reminders.',
  //         'OK',
  //         {
  //           duration: 3000,
  //         }
  //       );
  //       return;
  //     }

  //     let data = {
  //       rfqId: rfq.id,
  //       rfqRefNumber: rfq.refNumber,
  //       creationDate: rfq.rfqDate,
  //       vesselName: rfq.vesselName,
  //       quoteBeforeDate: rfq.quotedByDate,
  //       buyerName: rfq.buyerName,
  //       buyerLogo: rfq.organizationLogo,
  //       buyerCompanyName: rfq.buyerCompanyName,
  //       buyerEmail: rfq.buyerEmail,
  //       suppliers: this.selectedSupplierForReminders,
  //     };
  //     this.fullLoaderService.showLoader('Sending Reminders...');
  //     const response = await this.SettingsService.sendRfqRemindersByBuyer(data);
  //     if (response && response.success) {
  //       this.snack.open('Reminders sent successfully.', 'OK', {
  //         duration: 3000,
  //       });
  //     } else {
  //       this.snack.open('Failed to send reminders.', 'OK', {
  //         duration: 3000,
  //       });
  //     }

  //   }

  async onReminderClick(rfq: any) {
    // UI-only for now
    console.log('Reminder clicked for RFQ:', rfq);

    if (this.selectedSupplierForReminders.length < 1) {
      this.snack.open(
        'Please select at least one supplier with status Acknowledged or Unactioned to send reminders.',
        'OK',
        {
          duration: 3000,
        }
      );
      return;
    }

    let data = {
      rfqId: rfq.id,
      rfqRefNumber: rfq.rfqRefNumber,
      creationDate: this.formatDate(rfq.rfqDate),
      vesselName: rfq.vesselName,
      quoteBeforeDate: this.formatDate(rfq.quotedByDate),
      buyerName: rfq.buyerName,
      buyerLogo: rfq.organizationLogo,
      buyerCompanyName: rfq.buyerCompanyName,
      buyerEmail: rfq.buyerEmail,
      suppliers: this.selectedSupplierForReminders,
    };

    try {
      this.fullLoaderService.showLoader('Sending Reminders...');
      const response = await this.SettingsService.sendRfqRemindersByBuyer(data);

      if (response && response.success) {
        this.snack.open('Reminders sent successfully.', 'OK', {
          duration: 3000,
        });
      } else {
        this.snack.open('Failed to send reminders.', 'OK', {
          duration: 3000,
        });
      }
      this.fullLoaderService.hideLoader();
    } catch (error) {
      console.error('Error sending reminders:', error);
      this.snack.open('An error occurred while sending reminders.', 'OK', {
        duration: 3000,
      });
      this.fullLoaderService.hideLoader();
    }
  }
  async sendReminder(rfq: any, supplier: any) {
    console.log('Reminder clicked for RFQ:', rfq);
    let data = {
      rfqId: rfq.id,
      rfqRefNumber: rfq.rfqRefNumber,
      creationDate: this.formatDate(rfq.rfqDate),
      vesselName: rfq.vesselName,
      quoteBeforeDate: this.formatDate(rfq.quotedByDate),
      buyerName: rfq.buyerName,
      buyerLogo: rfq.organizationLogo,
      buyerCompanyName: rfq.buyerCompanyName,
      buyerEmail: rfq.buyerEmail,
      suppliers: [supplier],
    };
    try {
      this.fullLoaderService.showLoader('Sending Reminder...');
      const response = await this.SettingsService.sendRfqRemindersByBuyer(data);

      if (response && response.success) {
        this.snack.open('Reminder sent successfully.', 'OK', {
          duration: 3000,
        });
      } else {
        this.snack.open('Failed to send reminders.', 'OK', {
          duration: 3000,
        });
      }
      this.fullLoaderService.hideLoader();
    } catch (error) {
      console.error('Error sending reminders:', error);
      this.snack.open('An error occurred while sending reminders.', 'OK', {
        duration: 3000,
      });
      this.fullLoaderService.hideLoader();
    }
  }

  onCompareClick() {
    // UI-only for now
  }

  onAddClick() {
    // UI-only for now (e.g., open add-supplier dialog)
  }

  // toggleWrapDescription(event: MatSlideToggleChange) {
  //   this.isWrapDescription = event.checked;
  // }
  openCurrencyLink() {
    window.open('https://www.exchangerate-api.com/', '_blank');
  }

  selectedSuppliers: any[] = [];
  selectedSupplierForReminders: any[] = [];
  selectedSuppliersQuotationForCompare: any[] = [];

  // Select all suppliers except declined ones
  selectAllSuppliers(suppliers: any[], row: any) {
    suppliers.forEach((supplier) => {
      if (supplier.rfqStatus !== 15) {
        supplier.selected = this.masterSelected;
      }
    });
    this.updateSelectedSuppliers(suppliers);
  }

  // When a single supplier is selected/deselected
  checkIfAllSelected(suppliers: any[], row: any) {
    this.masterSelected = suppliers
      .filter((s) => s.rfqStatus !== 15)
      .every((s) => s.selected);

    this.updateSelectedSuppliers(suppliers);
  }

  // Update the array of selected suppliers
  updateSelectedSuppliers(suppliers: any[]) {
    this.selectedSuppliers = suppliers.filter(
      (supplier) => supplier.selected && supplier.rfqStatus !== 15
    );
    this.selectedSupplierForReminders = this.selectedSuppliers.filter(
      (supplier) => supplier.rfqStatus === 1 || supplier.rfqStatus === 2
    );
    this.selectedSuppliersQuotationForCompare = this.selectedSuppliers.filter(
      (supplier) => supplier.selected && supplier.rfqStatus === 3
    );
    console.log('Selected Suppliers:', this.selectedSuppliers);

    console.log(
      'Selected Suppliers for Reminders:',
      this.selectedSupplierForReminders
    );
    console.log(
      'Selected Suppliers for Comparison:',
      this.selectedSuppliersQuotationForCompare
    );
  }
  getReqCurrency(amount: any, currencyCode: any): string {
    return `${currencyCode ? currencyCode : ''} ${amount}`;
  }

  exchangeRatesCache: { [base: string]: any } = {}; // cache to avoid repeated API calls

  // getConvertedAmount(supplier: any, buyerCurrency: string): string {
  //   const amount = supplier.totalReqCost;
  //   if (!amount) return 'N/A';

  //   // when toggle is OFF -> show buyer currency
  //   if (!this.isWrapDescription) {
  //     return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
  //   }

  //   // when toggle is ON -> convert to supplier currency
  //   const supplierCurrency = supplier.supplierCurrencyCode;
  //   const rates = this.exchangeRatesCache[buyerCurrency];

  //   if (rates && rates[supplierCurrency]) {
  //     const converted = (amount * rates[supplierCurrency]).toFixed(2);
  //     return `${converted} ${supplierCurrency}`;
  //   }

  //   // fallback until rates are fetched
  //   return `${amount} ${buyerCurrency}`;
  // }

  getConvertedAmount(supplier: any, buyerCurrency: string): string {
    const amount = supplier.totalReqCost;
    if (!amount) return 'N/A';

    // when toggle is OFF -> show buyer currency
    if (!this.isWrapDescription) {
      return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
    }

    // when toggle is ON -> convert to supplier currency
    const supplierCurrency = supplier.supplierCurrencyCode || 'EUR';

    if (!supplierCurrency) {
      // this.snack.open(
      //   `Supplier "${supplier.supplierName}" does not have a currency code`,
      //   'Close',
      //   { duration: 4000 }
      // );
      return `${buyerCurrency ? buyerCurrency : ''} ${amount}`; // fallback
    }

    const rates = this.exchangeRatesCache[buyerCurrency];

    if (rates && rates[supplierCurrency]) {
      const converted = (amount * rates[supplierCurrency]).toFixed(3);
      return `${supplierCurrency} ${converted}`;
    }

    // currency code not found in API rates
    // this.snack.open(
    //   `Currency code "${supplierCurrency}" not supported for supplier "${supplier.supplierName}"`,
    //   'Close',
    //   { duration: 4000 }
    // );
    return `${buyerCurrency} ${amount}`;
  }

  toggleWrapDescription(event: any, row: any) {
    this.isWrapDescription = event.checked;

    if (this.isWrapDescription) {
      // fetch conversion rates for buyer currency if not already cached
      const baseCurrency = row.rfqReqCurrencyCode;

      if (!baseCurrency) {
        this.snack.open(`Buyer does not have a currency code`, 'Close', {
          duration: 4000,
        });
        return;
      }

      if (!this.exchangeRatesCache[baseCurrency]) {
        const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
        this.http.get(url).subscribe((res: any) => {
          if (res.result === 'success') {
            this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
            console.log(
              'Exchange rates fetched successfully:',
              res.conversion_rates
            );
          } else {
            console.error('API error:', res['error-type']);
          }
        });
      }
    }
  }

  get userIdAsString(): string {
    return this.userId.toString();
  }

  openChat(rfq: any, supplier: any) {
    this.headerData = {
      rfqId: rfq.rfqId,
      rfqDate: rfq.rfqDate,
      rfqRefNumber: rfq.rfqRefNumber,
      vesselName: rfq.vesselName,
      vesselImoNumber: rfq.vesselImoNumber,
      portName: rfq.portName,
      vesselEta: rfq.vesselEta,
      buyerId: rfq.buyerId,
      supplierId: supplier.supplierId,
    };

    this.isChatOpen = true;
  }

  closeChat() {
    this.isChatOpen = false;
  }


  createInvoice(poId: any,rfqId:any,quoteId:any,poStatusValue:any,buyerId: any){
    // redirect the supplier to create invoice page
    this.router.navigate(['/operations/create-invoice'], {
      queryParams: {
        poId: poId,
        rfqId:rfqId,
        quoteId:quoteId,
        poStatusValue:poStatusValue,
        buyerId: buyerId
      },
    });
  }

  async downloadPO(poId:number,referenceNo:any){

    this.fullLoaderService.showLoader()
    
    let fileName = referenceNo +'.pdf';
    
    let data = {
      purchaseOrderId: Number(poId),
    }
   

    const pdf = await this.PurchaseOrderService.generatePoPdf(data)

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; 
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()
  }

  togglePreview(value: boolean, row?: any ) {
    this.previewSection = value;
    this.previewDocs = [];
   
    if (row) {
       this.previewDocs = [...row.poAttachment]
    }
  }

  toggleContactPopUp(value: boolean, row?: any){
    this.showContactPopup = value;
  
    if(value){
      if(row){
  
        this.selectedBuyer = {
          companyName: row.buyerCompanyName,
          contactPerson: row.buyerContact,
          email: row.companyEmailId,
          phone: row.buyerCompanyPhoneNumber,
          address: row.buyerCompanyAddress,
          fax: row.buyerCompanyFax
      
        };
  
      }
  
    }
  }


  async generatePoExcel(poId:number,referenceNo:any){

    this.fullLoaderService.showLoader()
    
    let fileName = referenceNo +'.xlsx';
    
    let params = {
      purchaseOrderId: Number(poId),
    }
   

    const result = await this.PurchaseOrderService.fetchPoAttachmentExcelData(params)

    console.log(result,'result')


    
  const data = {
    purchaseOrderDetails: result.pdfData.purchaseOrder,
    buyerDetails: {  
      name: result.pdfData.buyer.company.name,
      address: result.pdfData.buyer.company.address,
      contact: result.pdfData.buyer.contact.person,
      phone: result.pdfData.buyer.company.phone,
      email: result.pdfData.buyer.contact.email,
      billingAddress: result.pdfData.termsAndConditions.billingAddress,
      vat: result.pdfData.taxDetails.vat,
    },
    supplierDetails: {
      name: result.pdfData.supplier.companyName,
      address: result.pdfData.supplier.address,
      contact: result.pdfData.supplier.contactName,
      phone: result.pdfData.supplier.phone,
      email: result.pdfData.supplier.email,
    },

    freightForwarderDetails: {
      PIC: result.pdfData.freightForwarder.pic,
      phone: result.pdfData.freightForwarder.phone,
      fax: result.pdfData.freightForwarder.fax,
      email: result.pdfData.freightForwarder.email,
      address: result.pdfData.freightForwarder.address,
    },
    portAgentDetails: {
      name: result.pdfData.portAgent.portAgencyName,
      phone: result.pdfData.portAgent.phoneNumber,
      fax: result.pdfData.portAgent.phoneFax,
      email: result.pdfData.portAgent.contact,
      contact: result.pdfData.portAgent.contact,
    },
    costSummary:{
      lineItemSubtotal: parseFloat(result.pdfData.priceDetails.subtotal || 0).toFixed(3),
      generalDiscountType: result.pdfData.priceDetails.generalDiscount?.type || 'percentage',
      generalDiscountValue: parseFloat(result.pdfData.priceDetails.generalDiscount?.value || 0),
      generalDiscountAmount: (result.pdfData.priceDetails.generalDiscount?.type || 'percentage') === 'percentage'
        ? (parseFloat(result.pdfData.priceDetails.subtotal || 0) * parseFloat(result.pdfData.priceDetails.generalDiscount?.value || 0) / 100).toFixed(3)
        : parseFloat(result.pdfData.priceDetails.generalDiscount?.value || 0).toFixed(3),
      taxAmount: parseFloat(result.pdfData.priceDetails.taxAmount || 0).toFixed(3),
      otherCharges: result.pdfData.priceDetails.freight,
      totalAdditionalCost: result.pdfData.priceDetails.freightTotal,
      currency: result.pdfData.priceDetails.currency?.currencyCode || '',
      grandTotal: parseFloat(result.pdfData.priceDetails.total || 0).toFixed(3)
    },

    vesselDetails: result.pdfData.vessel,
    portDetails: result.pdfData.port,
    priceDetails: result.pdfData.priceDetails,
    incotermDetails: result.pdfData.incotermDetails,
    taxDetails: result.pdfData.taxDetails,
    termsAndConditions: result.pdfData.termsAndConditions,
    documents: result.pdfData.documents,

    lineItems: result.pdfData.lineItems.map((item: {
      supplierPartNumber: any;
      requestedQuantity: any;
      supplierUom: any;
      discount: any;
      discountedUnitPrice: any;
      partNo: any;
      supplierPartNo: any;
      description: any;
      supplierQuantity: any;
      unitOfMeasure: any;
      supplierUOM: any;
      unitCost: any;
      discountPercent: any;
      totalCost: any;
      leadTime: any;
      supplierComment: any; partNumber: any; itemDescription: any; quantity: any; uom: any; buyerComments: any; 
}, index: number) => ({
      srNo: index + 1,
      partNumber: item.partNumber,
      supplierPartNumber: item.supplierPartNumber,
      itemDescription: item.itemDescription,
      requestedQty: item.requestedQuantity,
      quotedQuantity: item.supplierQuantity,
      requestedUom: item.supplierUom,
      quotedUom: item.supplierUOM,
      unitCost: item.unitCost,
      discount: item.discount,
      discountedUnitCost: item.discountedUnitPrice,
      totalCost: item.totalCost,
      
    }))
  };

  console.log(data,'data')

  

  const Excel = await import('exceljs');
  const workbook = new Excel.Workbook();
  const ws = workbook.addWorksheet('Purchase Order');

  // === TITLE ===
  ws.mergeCells('A1:G1');
  const title = ws.getCell('A1');
  title.value = 'Purchase Order';
  title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
  title.alignment = { horizontal: 'center', vertical: 'middle' };
  ws.addRow([]);

  // === QUOTATION DETAILS ===
  const quoteHeader = ws.addRow(['PURCHASE ORDER DETAILS']);
  quoteHeader.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'D9E1F2' },
  };
  quoteHeader.getCell(1).font = { bold: true };
  ws.addRow([]);

  // Quotation Info
  const poInfo = [
    [
      'Purchase Order Number:',
      data.purchaseOrderDetails.purchaseOrderRefNumber,
      '',
      'Requested Delivery Date:',
      data.purchaseOrderDetails.expectedDeliveryDate,
    ],
    [
      'Order Date:',
      data.purchaseOrderDetails.purchaseOrderDate,
      '',
     
      'Incoterms:',
      data.incotermDetails.locations,
    ],
    [
      'Quotation Number:',
      data.purchaseOrderDetails.quoteRefNumber,
      '',
      
      'Incoterms Location:',
      data.incotermDetails.locations,
    ],
    [
      'Quotation Date:',
      data.purchaseOrderDetails.quotationDate,
      '',
      'Vessel Name:',
      data.vesselDetails.name,
    ],
    [
      'Payment Terms:',
      data.termsAndConditions.buyersPaymentTerms,
      '',
      'Port Name:',
      data.portDetails.name,
    ]
  ];
  poInfo.forEach((r) => {
    const row = ws.addRow(r);
    row.eachCell((c) => (c.alignment = { vertical: 'middle' }));
  });
  ws.addRow([]);

      // === BUYER AND SUPPLIER DETAILS ===
      const BsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
      BsHeader.eachCell(c => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
      });
      ws.addRow([]);
  
      const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
        value
      ]);
      
      const supplierEntries = Object.entries(data.supplierDetails || {}).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
        value
      ]);
      
      // Ensure equal number of rows for both sections
      const bmaxRows = Math.max(buyerEntries.length, supplierEntries.length);
      const paddedBuyer = [...buyerEntries, ...Array(bmaxRows - buyerEntries.length).fill(['', ''])];
      const paddedSupplier = [...supplierEntries, ...Array(bmaxRows - supplierEntries.length).fill(['', ''])];
      
      // Add rows to worksheet (no borders, clean formatting)
      for (let i = 0; i < bmaxRows; i++) {
        const row = ws.addRow([
          paddedBuyer[i][0], paddedBuyer[i][1],
          '',
          paddedSupplier[i][0], paddedSupplier[i][1]
        ]);
      
      
      }
  
      ws.addRow([]);
      
      // const BsmaxRows = Math.max(
      //   Object.keys(data.buyerDetails).length,
      //   Object.keys(data.supplierDetails).length
      // );
  
      // const bd = Object.entries(data.buyerDetails);
      // const bpad = Array(BsmaxRows - bd.length).fill(['', '']);
      // const bpad2 = Array(BsmaxRows - Object.entries(data.supplierDetails).length).fill(['', '']);
      // const bpadData = bd.concat(bpad);
      // const supp = Object.entries(data.supplierDetails).concat(bpad2);
  
      // for (let i = 0; i < BsmaxRows; i++) {
      //   ws.addRow([
      //     bpadData[i][0],
      //     bpadData[i][1],
      //     '',
      //     supp[i][0],
      //     supp[i][1],
      //   ]);
      // }
  
     
  
  
     // === FREIGHT FORWARDER + PORT AGENT ===
    const faHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
    faHeader.eachCell(c => {
      c.font = { bold: true };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
    });
    ws.addRow([]);
  
    // const maxRows = Math.max(
    //   Object.keys(data.freightForwarderDetails).length,
    //   Object.keys(data.portAgentDetails).length
    // );
    // const ffd = Object.entries(data.freightForwarderDetails);
    // const pad = Array(maxRows - ffd.length).fill(['', '']);
    // const pad2 = Array(maxRows - Object.entries(data.portAgentDetails).length).fill(['', '']);
    // const padData = ffd.concat(pad);
    // const padAgent = Object.entries(data.portAgentDetails).concat(pad2);
  
    // for (let i = 0; i < maxRows; i++) {
    //   ws.addRow([
    //     padData[i][0],
    //     padData[i][1],
    //     '',
    //     padAgent[i][0],
    //     padAgent[i][1],
    //   ]);
    // }
  
    const freightEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    const portAgentEntries = Object.entries(data.portAgentDetails || {}).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    // Ensure equal number of rows for both sections
    const maxRows = Math.max(freightEntries.length, portAgentEntries.length);
    const paddedFreight = [...freightEntries, ...Array(maxRows - freightEntries.length).fill(['', ''])];
    const paddedPortAgent = [...portAgentEntries, ...Array(maxRows - portAgentEntries.length).fill(['', ''])];
    
    // Add rows to worksheet (no borders, clean formatting)
    for (let i = 0; i < maxRows; i++) {
      const row = ws.addRow([
        paddedFreight[i][0], paddedFreight[i][1],
        '',
        paddedPortAgent[i][0], paddedPortAgent[i][1]
      ]);
    
    
    }
  
    ws.addRow([]);

  // === LINE ITEMS ===
  const liHeader = ws.addRow(['Line Items']);
  liHeader.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'BDD7EE' },
  };
  liHeader.getCell(1).font = { bold: true };
  ws.addRow([]);

  const tableHeader = ws.addRow([
    'Sr. No',
    'Part Number',
    'Item Description',
    'Requested Qty',
    'Requested UOM',
    'Unit Cost',
    'Discount',
    'Discounted Unit Cost',
    'Total Cost' 
  ]);
  tableHeader.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' },
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // Add Line Items
  data.lineItems.forEach((item: {
    discountedUnitCost: any;
    supplierRemarks: any; srNo: any; partNumber: any; supplierPartNumber: any; itemDescription: any; requestedQty: any; quotedQuantity: any; requestedUom: any; quotedUom: any; unitCost: any; discount: any; totalCost: any; leadDays: any; supplierComment: any; 
}) => {
    const row = ws.addRow([
      item.srNo,
      item.partNumber,
      item.itemDescription,
      item.requestedQty,
      item.requestedUom,
      item.unitCost,
      item.discount,
      item.discountedUnitCost,
      item.totalCost

    ]);
    row.eachCell((cell) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.alignment = { wrapText: true, vertical: 'middle' };
    });
  });

  ws.addRow([]);



  const costSummaryHeader = ws.addRow(['Cost Summary']);
  costSummaryHeader.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'F9F9F9' },
  };
  costSummaryHeader.getCell(1).font = { bold: true };
  ws.addRow([]);

  // Cost Summary Table
  const costSummaryTableHeader = ws.addRow(['Description', 'Amount']);
  costSummaryTableHeader.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'D9D9D9' },
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // Line Total Amount
  const lineTotalRow = ws.addRow([
    'Line Total Amount',
    data.costSummary.lineItemSubtotal,
  ]);
  lineTotalRow.eachCell((cell) => {
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // General Discount Amount (only if > 0)
  if (parseFloat(data.costSummary.generalDiscountAmount) > 0) {
    const generalDiscountRow = ws.addRow([
      'General Discount Amount',
      `${data.costSummary.generalDiscountAmount}`,
    ]);
    generalDiscountRow.eachCell((cell) => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  }

  // Adding Additional Charges 
  let totalAdditionalCharges = 0;
  data.costSummary.otherCharges.forEach((charge: { description: any; value: number; }) => {
    const row = ws.addRow([charge.description, charge.value]);
    row.eachCell((cell) => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    totalAdditionalCharges += charge.value;
  });

  // Total Additional Cost
  const totalAdditionalCostRow = ws.addRow([
    'Total Additional Cost',
    totalAdditionalCharges,
  ]);
  totalAdditionalCostRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // Tax Amount (only if > 0)
  if (parseFloat(data.costSummary.taxAmount) > 0) {
    const taxAmountRow = ws.addRow([
      'Tax Amount',
      data.costSummary.taxAmount,
    ]);
    taxAmountRow.eachCell((cell) => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  }

  // Grand Total
  const grandTotalRow = ws.addRow([
    'Grand Total',
    `${data.costSummary.grandTotal} ${data.costSummary.currency}`,
  ]);
  grandTotalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  ws.addRow([]);

  const termsHeader = ws.addRow(['Terms And Conditions']);
  termsHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
  termsHeader.getCell(1).font = { bold: true };
  ws.addRow([]);
  ws.addRow([data.termsAndConditions.text]);
  ws.addRow([]);
  ws.addRow([]);


  // === VSMPS Buyer and Supplier section ===
  ws.addRow([`From VSMPS Buyer:`]);
  ws.addRow([data.buyerDetails.name]);
  ws.addRow([data.buyerDetails.address]);

  ws.addRow([]);

  ws.addRow([`To VSMPS Supplier:`]);
  ws.addRow([data.supplierDetails.name]);
  ws.addRow([data.supplierDetails.address]);

  ws.addRow([]);
  ws.addRow(['Copyright © Varuna Sentinels BV. All rights reserved.']);

  // === AUTO WIDTH ===
  const colCount = ws.actualColumnCount;
  for (let i = 1; i <= colCount; i++) {
    let maxLen = 12;
    ws.eachRow({ includeEmpty: true }, (r) => {
      const val = r.getCell(i).value;
      const len = val ? val.toString().length : 0;
      if (len > maxLen) maxLen = len;
    });
    ws.getColumn(i).width = Math.min(maxLen + 4, 40);
  }

  const fileSaverMod = await import('file-saver');
  const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, fileName);
  });


    this.fullLoaderService.hideLoader()
  }
}
